import { render } from "./TextbookFacetModal.vue?vue&type=template&id=5d0b6f10&scoped=true"
import script from "./TextbookFacetModal.vue?vue&type=script&lang=js"
export * from "./TextbookFacetModal.vue?vue&type=script&lang=js"

import "./TextbookFacetModal.vue?vue&type=style&index=0&id=5d0b6f10&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0b6f10"]])

export default __exports__